export default __webpack_public_path__ + "static/media/gallery-wip-neck_06.25013ee5.jpg";